import React, { useRef, useEffect, useState } from 'react';
import type { PrismicVideo } from '../../../../../types';

import * as S from './styles';

type Props = {
  className?: string;
  data: PrismicVideo;
};

const Video = ({ className, data }: Props) => {
  const videoRef: React.RefObject<HTMLDivElement> = useRef(null);
  const SCALE = 1.78; // 16:9 video format

  const [height, setHeight] = useState(0);

  useEffect(() => {
    const width =
      (videoRef && videoRef.current && videoRef.current.offsetWidth) || 0;
    setHeight(width / SCALE);
  }, []);

  const embedUrl = data.url.replace(/watch\?v=/, 'embed/');

  return (
    <S.Video ref={videoRef} className={className}>
      <iframe
        title="video"
        width="100%"
        height={height}
        src={embedUrl}
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </S.Video>
  );
};

export default Video;
